import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Icon } from '@iconify/react';

const FormModal = ({
  show,
  onHide,
  title,
  subtitle,
  children,
  onSave,
  onCancel,
  saveText = 'Salvar',
  cancelText = 'Cancelar',
  saveIcon = 'mdi:content-save',
  cancelIcon = 'mdi:close',
  titleIcon = 'mdi:form',
  saveVariant = 'primary',
  cancelVariant = 'outline-secondary',
  size = 'lg',
  loading = false,
  loadingText = 'Salvando...',
  disabled = false,
  className = '',
  ...props
}) => {
  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      size={size} 
      centered
      className={className}
      {...props}
    >
      <Modal.Header closeButton className="bg-primary text-white">
        <Modal.Title style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <Icon icon={titleIcon} style={{ fontSize: '20px', marginTop: '2px' }} />
          <span>{title}</span>
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body className="p-4">
        {subtitle && (
          <div className="alert alert-info mb-4" style={{ 
            display: 'flex', 
            alignItems: 'flex-start', 
            gap: '12px',
            padding: '16px'
          }}>
            <Icon icon="mdi:information" style={{ fontSize: '18px', marginTop: '2px', flexShrink: 0 }} />
            <span>{subtitle}</span>
          </div>
        )}
        
        {children}
      </Modal.Body>
      
      <Modal.Footer className="bg-light border-top">
        <Button 
          variant={cancelVariant} 
          onClick={onCancel || onHide}
          disabled={loading}
        >
          <Icon icon={cancelIcon} className="me-2" />
          {cancelText}
        </Button>
        
        <Button 
          variant={saveVariant} 
          onClick={onSave}
          disabled={loading || disabled}
        >
          {loading ? (
            <>
              <div className="spinner-border spinner-border-sm me-2" role="status">
                <span className="visually-hidden">{loadingText}</span>
              </div>
              {loadingText}
            </>
          ) : (
            <>
              <Icon icon={saveIcon} className="me-2" />
              {saveText}
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FormModal; 